// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1j938","buttons":"RemoveExpirationActionButtons_buttons__38m6Z"};